<script lang="ts">
export default {
    name: "AirportControl",
};
</script>

<script setup lang="ts">
import { store } from "@/store"
import { useDockControl } from './use-dock-control'
import { cmdList as baseCmdList, DeviceCmdItem } from '@/types/device-cmd'
import { EModeCode, EDockModeCode, EGear } from '@/types/device'
import { DeviceTypeName, EBizCode } from "@/types/enum";
import { updateDeviceCmdInfoByOsd, updateDeviceCmdInfoByExecuteInfo } from '@/utils/device-cmd'
import { rtkCalibration } from "@/api/device-cmd"
const {
    sendDockControlCmd,
    dockDebugOnOff
} = useDockControl()

const initCmdList = baseCmdList.map(cmdItem => Object.assign({}, cmdItem))
const cmdList = ref(initCmdList)

const str = '--'
const deviceInfo: any = reactive({
    gateway: {
        capacity_percent: str,
        transmission_signal_quality: str,
    },
    dock: {

    },
    device: {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: 0,
        vertical_speed: 0,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
            gps_number: str,
            is_fixed: 0,
            rtk_number: str
        },
        payload: [{
            gimbal_yaw: 0
        }],
        attitude_head: 0,
        battery: {
            capacity_percent: str,
            landing_power: str,
            remain_flight_time: 0,
            return_home_power: str,
        },
        latitude: str,
        longitude: str,
    }
})
const openValue = ref(deviceInfo.dock?.basicOsd?.mode_code === EDockModeCode.Remote_Debugging)

const openActive = ref(-1)
// 根据机场指令执行状态更新信息
watch(() => store.other.useMyStore().devicesCmdExecuteInfo, (devicesCmdExecuteInfo) => {
    console.log(devicesCmdExecuteInfo)
    if (store.informationListStore.informationStore().airNumberValue && devicesCmdExecuteInfo[store.informationListStore.informationStore().airNumberValue]) {
        updateDeviceCmdInfoByExecuteInfo(cmdList.value, devicesCmdExecuteInfo[store.informationListStore.informationStore().airNumberValue])
    }
}, {
    immediate: true,
    deep: true,
})

watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
    // console.log(data)
    if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[store.informationListStore.informationStore().uavObj.childSn]) {
        // console.log('设备状态:', data.deviceInfo)
        deviceInfo.device = data.deviceInfo[store.informationListStore.informationStore().uavObj.childSn]
    }
    if (data.currentType === DeviceTypeName.Dock && data.dockInfo[store.informationListStore.informationStore().airNumberValue]) {
        // console.log('机场状态:', data.dockInfo[store.informationListStore.informationStore().airNumberValue])
        // console.log(searchValue.value.gatewaySn)
        deviceInfo.dock = data.dockInfo[store.informationListStore.informationStore().airNumberValue]
        // console.log(deviceInfo.dock)
    }
}, {
    deep: true
})
// 根据设备osd信息更新信息
watch(() => deviceInfo, (value) => {
    updateDeviceCmdInfoByOsd(cmdList.value, value)
    openValue.value = deviceInfo.dock?.basicOsd?.mode_code === EDockModeCode.Remote_Debugging
    // console.log(props.deviceInfo.dock?.basic_osd?.mode_code, EDockModeCode.Remote_Debugging)
}, {
    immediate: true,
    deep: true
})
const disabledStatus = ref(false)
const onDeviceStatusChange = async () => {
    disabledStatus.value = true
    let result = false
    if (openValue.value) {
        result = await dockDebugOnOff(store.informationListStore.informationStore().airNumberValue, true)
    } else {
        result = await dockDebugOnOff(store.informationListStore.informationStore().airNumberValue, false)
    }
    console.log(result)
    if (!result) {
        if (openValue.value) {
            openValue.value = false
        } else {
            openValue.value = true
        }
    }
    const timer = setTimeout(() => {
        disabledStatus.value = false
    }, 2000)
}

async function sendControlCmd(cmdItem: DeviceCmdItem, index: number) {
    openActive.value = index
    const success = await sendDockControlCmd({
        sn: store.informationListStore.informationStore().airNumberValue,
        cmd: cmdItem.cmdKey,
        action: cmdItem.action
    }, true)
    if (success) {
        // updateDeviceSingleCmdInfo(cmdList.value[index])
    }
}

const rtkCalibrationBtn = () =>{
    const params:any = {}
    params.sn = store.informationListStore.informationStore().uavObj?.deviceSn
    params.longitude = deviceInfo?.dock?.workOsd?.self_converge_coordinate?.longitude
    params.latitude = deviceInfo?.dock?.workOsd?.self_converge_coordinate?.latitude
    params.height = deviceInfo?.dock?.workOsd?.self_converge_coordinate?.height
    params.module = store.informationListStore.informationStore().uavObj?.deviceType
    rtkCalibration(params).then((res:any)=>{
        ElMessage.success("标定成功")
    })
}

watch(()=>store.informationListStore.informationStore().uavObj,(newVal:any)=>{
    console.log(newVal)
    if(newVal && newVal.deviceType != 1){
        cmdList.value.splice(3,1)
    }
})

onMounted(() => {
    
})

</script>

<template>
    <div class="airportControl-box" :class="openValue ? 'airportControl-box-active' : ''">
        <div class="open-box">
            <el-form>
                <el-form-item label="机场远程控制" label-position="top">
                    <el-switch :disabled="disabledStatus" v-model="openValue" inline-prompt active-text="开"
                        inactive-text="关" @change="onDeviceStatusChange" />
                </el-form-item>
            </el-form>
        </div>
        <div class="air-box" v-if="openValue">
            <div class="controlList" v-for="(item, index) in cmdList" :key="item.cmdKey"
                :class="!openValue || item.disabled ? 'controlClose' : openActive == index ? 'controlOpen' : ''">
                <p>{{ item.label }}</p>
                <p style="color: #40F376;font-weight: normal;font-size: .75rem;">{{ item.status }}</p>
                <el-button :disabled="disabledStatus || item.disabled" :loading="item.loading" plain class="controlBtn"
                    @click="sendControlCmd(item, index)">
                    {{ item.operateText }}</el-button>
            </div>

            <div class="controlList" >
                <p>一键标定</p>
                <p style="color: #40F376;font-weight: normal;font-size: .75rem;">一键标定</p>
                <el-button plain class="controlBtn" @click="rtkCalibrationBtn">
                    一键标定</el-button>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.airportControl-box {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    width: 56.6vw;
    height: 20.1vh;
    z-index: 1;

    .open-box {
        position: absolute;
        bottom: 0;
        right: 0vw;
        pointer-events: all;
        :deep(.el-form-item__label) {
            color: #FFFFFF;
            text-shadow: 0px 4px 5px rgba(0, 0, 0, 0.3);
            font-family: AlibabaPuHuiTi;
        }

        .el-switch {
            :deep(.el-switch__label) {
                color: #E8EBEF;
            }

            :deep(.el-switch__core) {
                background: linear-gradient(115deg, rgba(73, 73, 73, 0.83) 0%, #DCDCDC 100%);
                border: none;
            }
        }

        .el-switch.is-checked {
            :deep(.el-switch__core) {
                background: linear-gradient(115deg, rgba(64, 255, 249, 0.83) 0%, #408CFF 100%);
                border: none;
            }
        }
    }

    .air-box {
        width: 63.6rem;
        display: flex;
        flex-wrap: wrap;
        align-items: start;
        margin-left: .6vw;

        .controlList {
            width: 7.6vw;
            height: 7.9vh;
            color: #fff;
            text-align: center;
            cursor: pointer;
            background: url("@/assets/icons/kongzhi.png") center no-repeat;
            background-size: 100% 100%;
            margin-top: 1.4vh;
            margin-right: .8vw;
            opacity: 1;
            pointer-events: auto;

            p:nth-child(1) {
                font-size: 1.125rem;
                font-weight: normal;
                font-family: YouSheBiaoTiHei;
                background: linear-gradient(180deg, #FFFFFF 25%, #9BE2FF 56%, #33CBFF 72%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                margin-top: .8vh;
            }

            p {
                line-height: 1.9vh;
                font-family: AlibabaPuHuiTi;
            }

            .controlBtn {
                width: 3.9vw;
                height: 2vh;
                background: linear-gradient(270deg, rgba(0, 248, 253, 0.8) 0%, rgba(0, 82, 248, 0.6) 100%);
                box-sizing: border-box;
                border: 0.5px solid;
                border-image: linear-gradient(270deg, #FFFFFF 0%, #007EFA 100%) 0.5;
                backdrop-filter: blur(5.44px);
                font-size: .75rem;
                color: #FFFFFF;
                font-family: AlibabaPuHuiTi;
                border-radius: 3px;
                margin-top: .2vh;
            }
        }

        .controlClose {
            // opacity: 0.5;
            pointer-events: none;
            background: url("@/assets/icons/kongzhi-hui.png") center no-repeat;
            background-size: 100% 100%;

            p:nth-child(1) {
                background: linear-gradient(180deg, #FFFFFF 25%, #C4C4C4 56%, #91A6AD 72%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }

            p {
                line-height: 1.9vh;
            }

            .controlBtn {
                width: 3.9vw;
                height: 2vh;
                background: linear-gradient(270deg, rgba(160, 165, 165, 0.8) 0%, rgba(126, 147, 190, 0.6) 100%);
                box-sizing: border-box;
                border: 0.5px solid;
                border-image: linear-gradient(270deg, #FFFFFF 0%, #7E868D 100%) 0.5;
                backdrop-filter: blur(5.44px);
                font-size: .75rem;
                color: #FFFFFF;
                border-radius: 3px;
                margin-top: .2vh;
            }
        }

        .controlOpen {
            background: url("@/assets/icons/kongzhi-active.png") center no-repeat;
            background-size: 100% 100%;

            p:nth-child(1) {
                background: linear-gradient(180deg, #FFFFFF 25%, #FFEB9B 56%, #FFBB00 72%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }

            p {
                line-height: 1.9vh;
            }

            .controlBtn {
                width: 3.9vw;
                height: 2vh;
                background: linear-gradient(270deg, rgba(253, 202, 0, 0.8) 0%, rgba(248, 128, 0, 0.6) 100%);
                box-sizing: border-box;
                border: 0.5px solid;
                border-image: linear-gradient(270deg, #FFFFFF 0%, #FAA700 97%) 0.5;
                backdrop-filter: blur(5.44px);
                font-size: .75rem;
                color: #FFFFFF;
                border-radius: 3px;
                margin-top: .2vh;
            }
        }
    }
}

.airportControl-box-active {
    background: linear-gradient(0deg, rgba(21, 31, 50, 0.464) 0%, rgba(24, 35, 58, 0.8) 97%);
    box-sizing: border-box;
    border: 1px solid;
    border-image: linear-gradient(180deg, #159AFF 12%, rgba(21, 154, 255, 0) 100%) 1;
    border-radius: 2px;
}
</style>
